import parsePhoneNumberFromString from "libphonenumber-js";
export function createPhoneLink(phoneNumber, className) {
    const parsedNumber = parsePhoneNumberFromString(phoneNumber);
    if (parsedNumber === null || parsedNumber === void 0 ? void 0 : parsedNumber.isValid()) {
        const classAttr = className ? ` class="${className}"` : "";
        return `<a href="${parsedNumber === null || parsedNumber === void 0 ? void 0 : parsedNumber.getURI()}"${classAttr}>${parsedNumber === null || parsedNumber === void 0 ? void 0 : parsedNumber.formatInternational()}</a>`;
    }
    return phoneNumber;
}
//# sourceMappingURL=createPhoneLink.js.map
